import { api } from '@/lib/api-client'
import type {
QueueSession,
QueueView,
CreateQueueSessionInput,
UpdateQueueSessionStatusInput,
PaginatedResponse,
} from '@/types'

interface ListQueueSessionsParams {
  shopId: string
  page?: number
  limit?: number
  status?: string
  customerId?: string
}

export const queueSessionsApi = {
  view: (shopId: string, registerId?: string | null) =>
    api.get<QueueView>(`/queue-sessions/view/${shopId}`, {
      params: registerId ? { registerId } : undefined,
    }),
  list: (params: ListQueueSessionsParams) =>
    api.get<PaginatedResponse<QueueSession>>('/queue-sessions', { params }),
  get: (id: string) =>
    api.get<QueueSession>(`/queue-sessions/${id}`),
  create: (data: CreateQueueSessionInput) =>
    api.post<QueueSession>('/queue-sessions', data),
  updateStatus: (id: string, data: UpdateQueueSessionStatusInput) =>
    api.patch<QueueSession>(`/queue-sessions/${id}/status`, data),
  assign: (id: string) =>
    api.patch<QueueSession>(`/queue-sessions/${id}/assign`, {}),
}
